import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const simulationSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'containerName': SortOptions.containerName,
  'updated': SortOptions.updated,
};